export default "__VITE_ASSET__HrbqeCF6__"